import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Image from "next/image";
import aboutHero from "../../public/assets/images/about/about-hero.png";
const AboutHeroSection = ({
  pillText = "~ We Are Neoverce IT Solutions ~",
  title = "Short Story",
  highlight = "About Our Company",
  description = "We are focused on developing and delivering high-performance and scalable software products to different industry domains. We have experience of developing and maintaining successful software products, eCommerce portals, marketplaces, social networks, real-time business analytics, and integrations. You can hire us per project.",
  image,
  imageAlt = "about-img",
}) => {
  return (
    <div className="about-hero">
      <Container>
        <Row>
          <Col lg={6} md={12} className="align-self-center">
            <div className="com-pill mb-4 animation-bottom mx-auto mx-lg-0">
              {pillText}
            </div>
            <h3 className="com-title animation-bottom text-center text-lg-start">
              {title} <span>{highlight}</span>
            </h3>
            <p className="animation-bottom text-center text-lg-start">
              {description}
            </p>
          </Col>
          <Col lg={6} md={12}>
            <Image
              src={image || aboutHero}
              alt={imageAlt}
              height={500}
              width={500}
              className="img-fluid mx-auto mx-lg-0 ms-lg-auto d-block animation-right"
              priority
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default AboutHeroSection;
